import { DateTimeField, PortAutocomplete, TextField } from 'form';
import { SectionContainer } from 'ui';

import { CarrierAutocomplete } from '~/carrier';

export const ShipmentCreateFieldsSection = () => {
  return (
    <>
      <SectionContainer title="General Shipment Fields">
        <TextField label="Bill of Lading Number" name="bill_of_lading_number" />
        <CarrierAutocomplete name="carrier_1_id" label="Carrier 1" />
        <CarrierAutocomplete name="carrier_2_id" label="Carrier 2" />
        <CarrierAutocomplete name="carrier_3_id" label="Carrier 3" />
        <TextField label="Carrier Booking Reference" name="carrier_booking_reference" />
        <DateTimeField label="Docs Cut-off Time" name="docs_cut_off_time" />
        <TextField label="Freight Forwarder Reference" name="freight_forwarder_reference" />
        <PortAutocomplete name="port_of_loading_id" label="Select port of loading" />
        <DateTimeField label="Scheduled Delivery Time" name="scheduled_delivery_time" />
        <DateTimeField label="VGM Cut-off Time" name="vgm_cut_off_time" />
        <TextField
          label="Free Time Available (Days)"
          name="free_time_available"
          type="number"
          inputProps={{ min: 0 }}
          helperText="Number of days of free time available for the buyer at the port of destination"
        />
        <TextField
          sx={{ gridColumn: 'span 3' }}
          label="Additional Invoice Description"
          name="additional_invoice_description"
          multiline
          rows="10"
        />
      </SectionContainer>
      <SectionContainer title="Shipment Tracking Fields">
        <DateTimeField label="Scheduled Port Departure Time" name="scheduled_port_departure_time" />
        <DateTimeField label="Manual Estimated Port Departure Time" name="manual_estimated_port_departure_time" />
        <DateTimeField label="Manual Actual Port Departure Time" name="manual_actual_port_departure_time" />
        <DateTimeField label="Scheduled Port Arrival Time" name="scheduled_port_arrival_time" />
        <DateTimeField label="Manual Estimated Port Arrival Time" name="manual_estimated_port_arrival_time" />
        <DateTimeField label="Manual Actual Port Arrival Time" name="manual_actual_port_arrival_time" />
      </SectionContainer>
    </>
  );
};
